<template>
  <div class="container_box">
    <Tabs v-model="pageParams.shelveStatus" :animated="false" class="tabs_styles" @on-click="search()">
      <TabPane v-for="item in salesStatusList" :label="item.title" :name="item.value.toString()"></TabPane>
    </Tabs>
    <!--头部筛选区域-->
    <div class="filter_box">
      <Form ref="pageParams" :model="pageParams" :label-width="labelWidth" @submit.native.prevent>
        <Row type="flex" :gutter="gutterItem">
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <dropDownFilter
              ref="dropDownFilter"
              inputType="textarea"
              :selectStyle="{width: '110px'}"
              :dropDownInputList="dropDownInputList"
              :defaultSelectValue="defaultSelectValue"
              @changeInput="changeInput"
              @updateInputValue="updateInputValue">
            </dropDownFilter>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1000599')">
              <Input :placeholder="$t('key1006984')" v-model.trim="pageParams.cnName" clearable></Input>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="configCharacters() + $t('key1000597')" prop="ymsProductCategoryId">
              <classificationSelect ref="classificationDom" @selectValue="changeValue"></classificationSelect>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1006985')">
              <Select v-model="pageParams.auditStatus" transfer filterable>
                <Option v-for="item in auditStatusList" :key="item.value" :value="item.value">{{ item.title }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1003344')" prop="productTypes">
              <Select v-model="pageParams.productTypes" transfer multiple :placeholder="$t('key1000101')">
                <Option v-for="item in productTypeList" :key="item.value" :value="item.value">{{ item.title }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col style="min-width: 200px;" push="1">
            <Button @click="reset" icon="md-refresh" class="mr10">{{ $t('key1000109') }}</Button>
            <Button type="primary" @click="search" icon="md-search">{{ $t('key1000361') }}</Button>
          </Col>
        </Row>
      </Form>
    </div>
    <!--功能按钮操作区域-->
    <div class="operation_box">
      <!--添加商品-->
      <Button class="mr15" type="primary" @click="addProduct" v-if="getPermission('productInfo_insert')">{{ $t('key1001092') }}</Button>
      <!--获取1688商品-->
      <Button class="mr15" @click="addAlibabaProduct">{{ $t('key1006988') }}</Button>
      <!--采集1688商品 userInfo.merchantId === '088025' -->
      <Button v-if="collectProductsTalg" class="mr15" @click="collectProductsBtn">{{ $t('key1006989') }}</Button>
      <!--导出商品-->
      <Dropdown transfer @on-click="exportProductBtn" class="mr15" v-if="getPermission('productGoods_excelExport')">
        <Button>
          <span>{{ $t('key1006986') }}</span>
          <Icon type="ios-arrow-down"></Icon>
        </Button>
        <DropdownMenu slot="list">
          <DropdownItem name="1">{{ $t('key1003083') }}</DropdownItem>
          <DropdownItem name="2">{{ $t('key1003084') }}</DropdownItem>
        </DropdownMenu>
      </Dropdown>
      <!--批量操作-->
      <Dropdown transfer class="mr15" @on-click="batchOperationBtn" v-if="batchButtonPermissions(batchOperationList)">
        <Button>
          <span>{{ $t('key1004754') }}</span>
          <Icon type="ios-arrow-down"></Icon>
        </Button>
        <DropdownMenu slot="list">
          <DropdownItem v-for="item in batchOperationList" :name="item.name" v-if="getPermission(item.permissionKey)">{{ item.title }}</DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </div>
    <!--列表区域-->
    <div class="table_box">
      <Table
        ref="selection"
        highlight-row
        :loading="tableLoading"
        border
        max-height="450"
        :columns="tableColumns"
        :data="tableData"
        @on-selection-change="tableChange">
      </Table>
      <Page
        :transfer="true"
        v-if="!tableLoading"
        :total="total"
        @on-change="changePage"
        show-total
        :page-size="pageParams.pageSize"
        show-elevator
        :current="pageParams.pageNum"
        show-sizer
        @on-page-size-change="changePageSize"
        placement="top"
        :page-size-opts="pageArray">
      </Page>
    </div>
    <!-- 操作日志 -->
    <operationLogModal ref="operationLogTalg" :productId="productId" operationType="spu"></operationLogModal>
    <!--批量改价弹窗-->
    <commonImportModal
      ref="batchPrice"
      :importTitle="$t('key1006978')"
      :uploadAction="batchPriceApi"
      :importOKText="$t('key1000329')"
      @updateData="updateData"
      importTemplateKey="batchPriceAdjustment">
      {{ $t('key1002622') }}<br/>
      {{ $t('key1006990') }}<br/>
      {{ $t('key1003922') }} .xls .xlsx .csv;<br/>
      {{ $t('key1003923') }}<br/>
      {{ $t('key1000274') }}<br/>
    </commonImportModal>
    <!--修改价格弹窗-->
    <modifyPriceModal ref="modifyPrice" @updateData="updateData"></modifyPriceModal>
    <!--导入商品弹窗-->
    <importCommodityInfoModal
      :isSelfOperated="0"
      ref="commodityInfo"
      :importInterface="importInterface"
      @updateData="updateData">
    </importCommodityInfoModal>
    <!--获取1688商品弹窗-->
    <alibabaProductModal ref="alibabaProduct" @updateData="updateData"></alibabaProductModal>
    <!--批量上架/停售弹窗-->
    <commonImportModal
      ref="batchListing"
      :importTitle="$t('key1006979')"
      :uploadAction="batchListingApi"
      :importOKText="$t('key1000329')"
      @updateData="updateData"
      importTemplateKey="updateProductGoodsStatus">
      {{ $t('key1002622') }}<br/>
      {{ $t('key1006991') }}<br/>
      {{ $t('key1003922') }} .xls .xlsx .csv;<br/>
      {{ $t('key1003923') }}<br/>
      {{ $t('key1000274') }}<br/>
    </commonImportModal>
    <!--导入库存的弹窗-->
    <commonImportModal
      ref="importInventory"
      :importTitle="$t('key1000765')"
      importType="privateWarehouse"
      :uploadAction="importUrl"
      :importOKText="$t('key1000329')"
      fileName="files"
      @uploadSuccess="search()"
      importTemplateKey="inventory">
    </commonImportModal>
    <!--库存详情弹窗-->
    <inventoryDetailsModal ref="inventoryDetails" @updateData="updateData"></inventoryDetailsModal>
    <!--导出订单字段弹窗-->
    <exportFieldsModal
      ref="exportFields"
      :exportFieldsTitle="$t('key1006986')"
      paramKeyColums="supplierProductInfoColumns"
      :customFieldExportList="customFieldExportList"
      @exportFieldsDataBtn="exportFieldsDataBtn">
    </exportFieldsModal>
    <!--供货价、直发价弹窗-->
    <commodityPriceModal ref="commodityPrice"></commodityPriceModal>
    <!--仓库信息完善提示弹窗-->
    <Modal v-model="completeWarehouseInfoModal" :title="$t('key1006987')" :transfer="false" :mask-closable="true">
      <p class="mt5 mb5">
        {{ $t('key1006992') }}
        {{ $t('key1006993') }}
      </p>
      <template #footer>
        <Button class="mr15" @click="completeWarehouseInfoModal = false">{{ $t('key1000112') }}</Button>
        <Button class="mr15" type="primary" @click="goConfigWarehouse">{{ $t('key1006994') }}</Button>
      </template>
    </Modal>
    <!--打印条码、二维码弹窗-->
    <printYunSkuModal ref="printYunSku" :printUrl="printUrl"></printYunSkuModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from "@/components/mixin/common_mixin";
import api from '@/api/';
import operationLogModal from "@/components/common/operationLogModal";
import dropDownFilter from "@/components/common/dropDownFilter";
import commonImportModal from "@/components/common/commonImportModal";
import {PRODUCTTYPES} from "@/utils/enum";
import importCommodityInfoModal from "@/components/common/importCommodityInfoModal.vue";
import alibabaProductModal from "@/views/supplier/components/productCenter/alibabaProductModal";
import modifyPriceModal from "@/views/supplier/components/productCenter/modifyPriceModal";
import inventoryDetailsModal from "@/components/common/inventoryDetailsModal.vue";
import {
  pageJump, amountHandel, setConfigCharacters, commonSessionStorage, commonCopyContent,
  getBatchCategoryInfoData, getBatchSupplierWarehouseData, getStoreGoodsData,
  batchAllWarehouseData, commonLocalStorage, getAllCountrysData, getCloudTreeData, getDataSetBatchList, getEnumList
} from "@/utils/common";
import exportFieldsModal from "@/components/common/exportFieldsModal.vue";
import classificationSelect from "@/components/common/classificationSelect.vue";
import commodityPriceModal from "@/components/common/commodityPriceModal.vue";
import printYunSkuModal from "@/views/yms/components/commodityManage/printYunSkuModal.vue";

export default {
  name: "productGoods",
  mixins: [Mixin],
  components: {
    printYunSkuModal,
    classificationSelect,
    exportFieldsModal,
    operationLogModal,
    dropDownFilter,
    commonImportModal,
    importCommodityInfoModal,
    alibabaProductModal,
    modifyPriceModal,
    inventoryDetailsModal,
    commodityPriceModal
  },
  data() {
    let v = this;
    return {
      defaultSelectValue: 1,
      dropDownInputList: [
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001093'), value: 1, placeholder: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001094'), parameterKey: 'spuList'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000586'), value: 2, placeholder: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006976'), parameterKey: 'skus'},
        {title: `${setConfigCharacters(false)}SPU`, value: 3, placeholder: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000324')}${setConfigCharacters(false)}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001089')}`, parameterKey: 'ymsSpuList'},
        {title: `${setConfigCharacters(false)}SKU`, value: 4, placeholder: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000324')}${setConfigCharacters(false)}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006974')}`, parameterKey: 'ymsSkus'}
      ],
      total: 0, // 总记录数
      pageParamsStatus: false, // 是否重新加载货品列表数据
      pageParamsPrototype: null, // 当前货品信息原型(重置用到)
      pageParams: { // 货品列表筛选参数
        cnName: null,
        orderBy: 'createdTime',
        upDown: 'down',
        pageSize: 50,
        pageNum: 1,
        ymsProductCategoryId: null,
        ymsSpuList: '',
        skus: '',
        ymsSkus: '',
        spuList: '',
        auditStatus: 'null',
        shelveStatus: '1',
        productTypes: []
      },
      tableData: [],
      tableColumns: [
        {
          type: 'selection',
          width: 60,
          fixed: 'left',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000383'),
          key: 'commodityInfo',
          align: 'left',
          minWidth: 350,
          render(h, params) {
            let supplierSpu = params.row.spu || ''; // 供应商SPU
            let ymsSpu = params.row.ymsSpu || ''; // 云卖SPU
            let name = params.row.name;
            let list = [
              v.tableImg(h, params, 'imagePath'),
              h('div', {
                class: 'text-align-left pl10'
              }, [
                h('Alink', {
                  props: {
                    linkName: name,
                    textAlign: 'left',
                    className: 'mb5',
                    AlinkShow: v.getPermission('productInfo_detail')
                  },
                  on: {
                    AlinkBtn: () => {
                      const {href} = v.$router.resolve({
                        path: '/productDetails',
                        query: {
                          type: 'look',
                          productId: params.row.productId
                        }
                      });
                      window.open(href, '_blank');
                    }
                  }
                }),
                h('p', {class: 'flex align-items-center'}, [
                  h('span', {style: {color: '#000'}}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000600') + supplierSpu),
                  supplierSpu ? h('Icon', {
                    props: {
                      type: 'ios-copy-outline',
                      size: 18,
                      color: '#01a6ee'
                    },
                    style: {
                      marginLeft: '10px',
                      cursor: 'pointer'
                    },
                    attrs: {
                      title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000003')
                    },
                    on: {
                      click: () => {
                        commonCopyContent(supplierSpu, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000002'));
                      }
                    }
                  }) : ''
                ]),
                h('p', {class: 'flex align-items-center'}, [
                  h('span', {style: {color: '#000'}}, `${setConfigCharacters(false)}SPU：` + ymsSpu),
                  ymsSpu ? h('Icon', {
                    props: {
                      type: 'ios-copy-outline',
                      size: 18,
                      color: '#01a6ee'
                    },
                    style: {
                      marginLeft: '10px',
                      cursor: 'pointer'
                    },
                    attrs: {
                      title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000003')
                    },
                    on: {
                      click: () => {
                        commonCopyContent(ymsSpu, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000002'));
                      }
                    }
                  }) : ''
                ]),
              ])
            ];
            return h('div', {
              class: 'flex ptb10',
            }, list)
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003442'),
          key: 'classificationName',
          minWidth: 260,
          align: 'left'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003445'),
          key: 'auditStatus',
          minWidth: 120,
          align: 'left',
          render: (h, params) => {
            let status = params.row.auditStatus;
            let title = '';
            v.auditStatusList.map((item) => {
              if (item.value === status) {
                title = item.title;
              }
            });
            return h('div', [
              h('span', title),
              status === 2 ? h('Tooltip', {
                props: {
                  transfer: true,
                  maxWidth: 150,
                  content: params.row.shelvedRejectReason
                },
                style: {
                  marginLeft: '5px'
                }
              }, [
                h('Icon', {
                  props: {
                    type: 'md-information-circle',
                    size: 18
                  },
                  style: {
                    cursor: 'pointer',
                    color: 'red'
                  }
                })
              ]) : ''
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000695'),
          key: 'skuNumber',
          minWidth: 120,
          align: 'left',
          sortable: true,
          render(h, params) {
            return h('Alink', {
              props: {
                linkName: params.row.skuNumber,
                textAlign: 'left',
                className: 'themeColor',
                AlinkShow: v.getPermission('productInfo_queryForSkuList')
              },
              on: {
                AlinkBtn: () => {
                  const {href} = v.$router.resolve({
                    path: '/supplierViewSku',
                    query: {
                      productId: params.row.productId,
                      systemType: 'supplier'
                    }
                  });
                  window.open(href, '_blank');
                }
              }
            })
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001102'),
          key: 'wmsInventoryQuantity',
          minWidth: 140,
          align: 'left',
          sortable: true,
          render(h, params) {
            return h('Alink', {
              props: {
                linkName: params.row.wmsInventoryQuantity,
                textAlign: 'left',
                className: 'themeColor',
                AlinkShow: true
              },
              on: {
                AlinkBtn: () => {
                  v.$refs['inventoryDetails'].initInventoryDetails('supplier_supplierInventory', params.row);
                }
              }
            })
          }
        },
        {
          title: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006407')}`,
          key: 'ymsInventoryQuantity',
          minWidth: 140,
          align: 'left',
          sortable: true,
          render(h, params) {
            return h('Alink', {
              props: {
                linkName: params.row.ymsInventoryQuantity,
                textAlign: 'left',
                className: 'themeColor',
                AlinkShow: true
              },
              on: {
                AlinkBtn: () => {
                  v.$refs['inventoryDetails'].initInventoryDetails('supplier_ymsInventory', params.row);
                }
              }
            })
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000873'),
          key: 'warehouseDirectDeliveryPrice',
          minWidth: 200,
          align: 'left',
          renderHeader(h) {
            return h("div", aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000582') + v.currencyState + "）");
          },
          render: (h, params) => {
            let wmsInventories = params.row.wmsInventories || [];
            let newList = wmsInventories.filter((item) => item.isDeliveryWarehouseTalg === true);
            let list = newList.map(item => item.productCost);
            let max = '';
            let min = '';
            let num = 0;
            if (list && list.length > 0) {
              min = amountHandel(Math.min(...list));
              max = amountHandel(Math.max(...list));
              if (list.length <= 0) {
                if (max === 0) {
                  num = 0;
                } else {
                  num = max;
                }
              } else {
                if (min === max) {
                  num = max;
                } else {
                  num = min + ' ~ ' + max;
                }
              }
            }
            let linkName = num + ' ' + (v.currencyState ? '(' + v.currencyState + ')' : '');
            return h('Alink', {
              props: {
                linkName: linkName,
                textAlign: 'left',
                className: 'themeColor',
                AlinkShow: true
              },
              on: {
                AlinkBtn: () => {
                  v.$refs['commodityPrice'].initCommodityPriceData('productCost', params.row);
                }
              }
            });
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002451'),
          key: 'time',
          align: 'left',
          width: 250,
          render: (h, params) => {
            let updatedTime = params.row.updatedTime ? v.$uDate.dealTime(params.row.updatedTime, 'fulltime') : '-';
            let createdTime = params.row.createdTime ? v.$uDate.dealTime(params.row.createdTime, 'fulltime') : '-';
            return h('div', {
              style: {
                textAlign: 'left'
              }
            }, [
              h('p', `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001180')}${createdTime}`),
              h('p', `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006975')}${updatedTime}`)
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          width: 210,
          fixed: 'right',
          align: 'left',
          render(h, params) {
            let auditStatus = params.row.auditStatus; // 审核状态
            let shelveStatus = params.row.shelveStatus; // 销售状态
            let productId = params.row.productId;
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000401'),
                    show: v.getPermission('productInfo_update') && auditStatus === 1,
                    clickFn: () => {
                      const {href} = v.$router.resolve({
                        path: '/productDetails',
                        query: {
                          type: 'look',
                          productId: productId
                        }
                      });
                      window.open(href, '_blank');
                    },
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000985'),
                    show: v.getPermission('productInfo_update') && auditStatus !== 1, // 待审核的商品不可编辑
                    clickFn: () => {
                      const {href} = v.$router.resolve({
                        path: '/productDetails',
                        query: {
                          type: 'edit',
                          productId: productId
                        }
                      });
                      window.open(href, '_blank');
                    },
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000594'),
                    show: v.getPermission('productGoods_appendProductGoodsExpressBill') && shelveStatus !== 0,
                    clickFn: () => {
                      v.$refs['printYunSku'].getProductDetails(productId, 0, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000594'));
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000595'),
                    show: v.getPermission('productGoods_appendProductGoodsExpressBill') && shelveStatus !== 0,
                    clickFn: () => {
                      v.$refs['printYunSku'].getProductDetails(productId, 1, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000595'));
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000539'),
                    show: shelveStatus === 1 && v.getPermission('productInfo_undercarriage'),
                    clickFn: () => {
                      v.shelfBtn(productId);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000593'),
                    show: shelveStatus === 2 && v.getPermission('productInfo_dercarriage'),
                    clickFn: () => {
                      v.groundingBtn(productId);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006977'),
                    show: v.getPermission('productGoods_batchUpdatePrice'),
                    clickFn: () => {
                      v.$refs['modifyPrice'].getModifyPriceList(productId);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003337'),
                    show: v.getPermission('productInfo_queryForSkuList'),
                    clickFn: () => {
                      const {href} = v.$router.resolve({
                        path: '/supplierViewSku',
                        query: {
                          productId: params.row.productId,
                          systemType: 'supplier'
                        }
                      });
                      window.open(href, '_blank');
                    }
                  },
                  {
                    text: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000401')}${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006407')}`,
                    show: true,
                    clickFn: () => {
                      v.$refs['inventoryDetails'].initInventoryDetails('supplier_ymsInventory', params.row);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003339'),
                    show: true,
                    clickFn: () => {
                      v.$refs['inventoryDetails'].initInventoryDetails('supplier_supplierInventory', params.row);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000288'),
                    show: v.getPermission('productGoodsOperationLog_query'),
                    clickFn: () => {
                      v.productId = productId;
                      v.$refs['operationLogTalg'].initializeData(productId);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000105'),
                    show: v.getPermission('productInfo_delete') && (auditStatus === 0 || shelveStatus === 2
                      || (auditStatus === 2 && shelveStatus === 0)), // 只有草稿状态、停售的商品(待审核、停售), 暂存且审核驳回状态, 可以删除
                    clickFn: () => {
                      v.deleteSpu(productId);
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ], // 供应商商户的货品列表
      productId: null,
      selectTableData: [],
      batchPriceApi: api.post_productGoods_excelPricesImport,
      batchListingApi: api.post_productGoods_excelSkuStatusImport,
      importUrl: api.post_productInfo_inventoryExcelImport,
      batchOperationList: [
        {name: '1', permissionKey: 'productInfo_excelImport', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000257')},
        {name: '2', permissionKey: 'productInfo_inventoryExcelImport', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000765')},
        {name: '3', permissionKey: 'productGoods_excelPricesImport', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006978')},
        {name: '4', permissionKey: 'productGoods_excelSkuStatusImport', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006979')},
      ],
      exportType: null,
      customFieldExportList: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000929'),
          titleKey: 'basicInfoColums',
          selectList: [], // 选中导出字段的key
          checkBoxList: [
            {paramKey: 'spu', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001093')},
            {paramKey: 'sku', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000586')},
            {paramKey: 'ymsSpu', paramValue: `${setConfigCharacters(false)}SPU`},
            {paramKey: 'ymsSku', paramValue: `${setConfigCharacters(false)}SKU`},
            {paramKey: 'cnName', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000380')},
            {paramKey: 'ymsProductCategoryName', paramValue: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003442')}`},
            {paramKey: 'status', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000590')},
            {paramKey: 'productGoodsSpecification', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000587')},
            {paramKey: 'ymsWarehouseName', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000241')},
            {paramKey: 'ymsWarehouseType', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002581')},
            {paramKey: 'allottedQuantity', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000242')},
            {paramKey: 'availableQuantity', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000243')},
            {paramKey: 'supplierDeliveryPrice', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000873')},
            {paramKey: 'supplyPrice', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003322')},
            {paramKey: 'productTypeStr', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003328')},
            {paramKey: 'originalCountryCode', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001607')}
          ]
        }
      ],
      productTypeList: PRODUCTTYPES,
      completeWarehouseInfoModal: false,
      enumData: [],
      importInterface: api.post_productInfo_excelImport,
      printUrl: api.post_productGoods_appendProductGoodsExpressBill
    };
  },
  computed: {
    filterKeyList() {
      return this.dropDownInputList.map((item) => {
        return item.parameterKey
      });
    },
    // 获取当前登录用户的信息
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    },
    // 获取配置采集商品功能
    collectProductsTalg() {
      const obj = commonLocalStorage.getItem('supplierConfigurationItemInfo') ?? this.$store.state.supplierConfigurationItemInfo;
      return obj?.collectGoodsConfig === 'Y';
    },
    // 审核状态
    auditStatusList() {
      const ENUM_KEY = 'ProductInfoAuditStatusSupplierEnum';
      let list = getEnumList(this.enumData, ENUM_KEY, 'number');
      list.unshift({
        value: 'null',
        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110')
      });
      return list;
    },
    // 销售状态
    salesStatusList() {
      const ENUM_KEY = 'ProductInfoShelveStatusSupplierEnum';
      let list = getEnumList(this.enumData, ENUM_KEY, 'number');
      // 自定义顺序
      const order = [1, 2, 0]
      list.sort((a, b) => {
        return order.indexOf(a.value) - order.indexOf(b.value)
      });
      return list;
    },
  },
  created() {
    this.handleColumns().then(() => {
      this.pageParamsPrototype = this.deepCopy(this.pageParams);
      if (this.$route.query) {
        if (this.$route.query.auditStatus) {
          this.pageParams.auditStatus = this.$route.query.auditStatus;
        }
        if (this.$route.query.shelveStatus) {
          this.pageParams.shelveStatus = this.$route.query.shelveStatus;
        }
      }
      this.defaultConditionQuery();
    });
  },
  methods: {
    // 初始化接口数据
    initFun() {
      (async () => {
        let enumKeyList = ['ProductInfoAuditStatusSupplierEnum', 'ProductInfoShelveStatusSupplierEnum'];
        this.enumData = await getDataSetBatchList(enumKeyList);
        await this.getCloudSalesClassification();
        await this.search();
      })();
    },
    // 触发带着默认条件查询
    defaultConditionQuery() {
      // 条件1：从获取/采集1688商品跳转过来 → 切换到暂存状态查询
      let alibabaProductsTalg = localStorage.getItem('1688ProductTalg') ? JSON.parse(localStorage.getItem('1688ProductTalg')) : '';
      if (alibabaProductsTalg) {
        this.pageParams.shelveStatus = '0';
        this.initFun();
        return;
      }
      // 条件2：从备货单-创建备货单-无法备货弹窗跳转过来 → 预填供应商SKU搜索条件
      let unableToStockUpSkus = localStorage.getItem('unableToStockUpSkus');
      if (unableToStockUpSkus) {
        this.defaultSelectValue = 2;
        this.$nextTick(() => {
          if (this.$refs.dropDownFilter) {
            this.$refs.dropDownFilter.inputValue = unableToStockUpSkus;
          }
          this.initFun();
        });
        return;
      }
      // 无默认条件 → 正常初始化查询
      this.initFun();
    },
    // 获取云卖分类的数据
    getCloudSalesClassification() {
      let obj = commonSessionStorage.getItem('erpConfig');
      let ymsSiteId = obj ? obj.ymsSite ? obj.ymsSite.ymsSiteId : null : null;
      getCloudTreeData(api.post_ymsProductCategory_api_queryAll, 'tile', null, ymsSiteId).then((data) => {
        this.$nextTick(() => {
          this.$refs['classificationDom'].initClassificationData(data);
        });
      });
    },
    // 分类筛选
    changeValue(value) {
      this.pageParams.ymsProductCategoryId = value;
    },
    // 查询按钮
    search() {
      let v = this;
      v.pageParams.pageNum = 1;
      v.getList();
    },
    // 重置
    reset() {
      let v = this;
      v.pageParams = v.deepCopy(this.pageParamsPrototype);
      v.pageParams.ymsProductCategoryId = null;
      v.changeInput(1);
      v.$nextTick(() => {
        v.$refs['classificationDom'].reset();
      });
    },
    // 新增商品
    addProduct() {
      let newList = [];
      getBatchSupplierWarehouseData([this.userInfo.merchantId]).then((data) => {
        newList = data.filter((item) => {
          return item.isCollectionWarehouseTalg || item.isDeliveryWarehouseTalg
        })
        if (newList.length > 0) {
          const {href} = this.$router.resolve({
            path: '/productDetails',
            query: {
              type: 'add'
            }
          });
          window.open(href, '_blank');
        } else {
          this.completeWarehouseInfoModal = true;
        }
      })
    },
    // 去配置发货仓
    goConfigWarehouse() {
      this.completeWarehouseInfoModal = false;
      this.$router.push('/supplierWarehouseManage');
    },
    // 获取1688商品
    addAlibabaProduct() {
      this.$refs['alibabaProduct'].initFunAlibabaProduct();
    },
    // 删除spu
    deleteSpu(productId) {
      let v = this;
      v.$Modal.confirm({
        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000584'),
        onOk: () => {
          v.axios.delete(api.delete_productInfo + productId).then(response => {
            let code = response.data.code;
            let datas = response.data.datas || [];
            let unusualObj = {
              210018: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006980'),
              210015: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006981'),
              210058: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006982'),
              999999: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006983'),
            };
            if (datas.length > 0) {
              for (let i = 0; i < datas.length; i++) {
                let data = datas[i];
                let text = `SKU：${data.sku}${unusualObj[data.code]}`
                v.$Message.warning(text);
              }
            } else if (code === 0) {
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000779'));
              v.search();
            }
          });
        },
        onCancel: () => {
        }
      });
    },
    // 参数处理
    handleParameter() {
      let v = this;
      let params = Object.assign({}, v.pageParams);
      params.shelveStatus = Number(v.pageParams.shelveStatus);
      let keyList = ['auditStatus'];
      for (let key of keyList) {
        params[key] = v.pageParams[key] === 'null' ? null : v.pageParams[key];
      }
      for (let key in params) {
        if (v.filterKeyList.includes(key)) {
          params[key] = v.sepCommasFn(params[key], ['\n']);
        }
      }
      return params;
    },

    // 获取商品列表
    getList() {
      let v = this;
      v.tableData = [];
      v.optionBtnWidth = [];
      v.total = 0;
      if (v.getPermission('productInfo_query')) {
        v.tableLoading = true;
        v.axios.post(api.post_productInfo_query, v.handleParameter()).then(response => {
          if (response.data.code === 0) {
            localStorage.removeItem('1688ProductTalg');
            localStorage.removeItem('unableToStockUpSkus');
            let data = response.data.datas;
            let ymsProductCategoryIds = [];
            if (data) {
              let list = data.list || [];
              list.map((item) => {
                ymsProductCategoryIds.push(item.ymsProductCategoryId)
              });
              if (ymsProductCategoryIds.length > 0) {
                getBatchCategoryInfoData(api.post_ymsProductCategory_api_queryDetailByCategoryIds, list, ymsProductCategoryIds).then((newData) => {
                  v.handleTableData(newData);
                })
              } else {
                v.handleTableData(list);
              }
              v.total = data.total;
            }
          } else {
            v.tableLoading = false;
          }
        });
      } else {
        v.gotoError();
      }
    },
    // 处理列表数据
    handleTableData(data) {
      const ymsWarehouseIds = [...new Set(data.flatMap(item => (item.wmsInventories || []).map(ele => ele.warehouseId)))];
      if (ymsWarehouseIds.length === 0) {
        this.tableData = data;
        this.updateTableDom('selection');
        return;
      }
      batchAllWarehouseData(ymsWarehouseIds).then(list => {
        const warehouseMap = {};
        list.forEach(warehouse => {
          const settings = warehouse.ymsWarehouseDeliverySettings || [];
          warehouse.isDeliveryWarehouseTalg = warehouse.isDeliveryWarehouse === 1 && settings.length > 0;
          warehouseMap[warehouse.ymsWarehouseId] = warehouse;
        });
        data.forEach(item => {
          (item.wmsInventories || []).forEach(ele => {
            ele.isDeliveryWarehouseTalg = warehouseMap[ele.warehouseId]?.isDeliveryWarehouseTalg || false;
          });
        });
        this.tableData = data;
        this.updateTableDom('selection');
      });
    },
    // 停售SPU商品
    shelfBtn(productId) {
      let v = this;
      v.axios.put(api.put_productInfo_productId + `${productId}`).then(response => {
        if (response.data.code === 0) {
          this.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000097'));
          v.getList();
        }
      });
    },
    // 上架SPU商品
    groundingBtn(productId) {
      let v = this;
      v.axios.put(api.put_productInfo_dercarriage + `${productId}`).then(response => {
        if (response.data.code === 0) {
          this.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000097'));
          v.getList();
        }
      });
    },
    // 获取下拉选项筛选条件的值
    updateInputValue(data) {
      this.pageParams[data.key] = data.value;
    },
    // 改变默认下拉选项的值
    changeInput(value) {
      this.defaultSelectValue = value;
      this.$refs.dropDownFilter.inputValue = '';
      this.dropDownInputList.map((item) => {
        if (Object.keys(this.pageParams).includes(item.parameterKey)) {
          this.pageParams[item.parameterKey] = '';
        }
      });
    },

    // 选择导出数据类型  1 按选中导出 2 按查询结果导出
    exportProductBtn(value) {
      this.exportType = value;
      if (value === '1') {
        if (this.selectTableData.length <= 0) {
          this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003077'));
          return false;
        }
      } else {
        if (this.tableData.length <= 0) {
          this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003078'));
          return false;
        }
      }
      this.$refs['exportFields'].getExportFieldsSetting();
    },
    // 导出数据
    exportFieldsDataBtn(obj) {
      let v = this;
      let query = v.handleParameter();
      if (v.exportType === '1') {
        query.productIds = v.selectTableData.map((item) => {
          return item.productId
        });
      } else {
        query.productIds = [];
      }
      v.$refs['exportFields'].saveExportFieldsSetting().then((value) => {
        if (value) {
          v.axios.post(api.post_productGoods_excelExport, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(res => {
            if (res.data.code === 0) {
              v.$refs['exportFields'].exportFieldsModal = false;
              let taskNumber = res.data.datas;
              setTimeout(() => {
                pageJump('/supplier.html#/exportTask?operateCode=' + taskNumber, '/yms-supplier-service', '_blank');
              }, 30)
            }
          });
        }
      });
    },

    // 操作之后，更新列表数据
    updateData(val) {
      if (val === '1688ProductTalg') {
        this.pageParams.shelveStatus = '0';
      }
      this.pageParamsStatus = true;
    },
    // 勾选列表数据
    tableChange(data) {
      this.selectTableData = [];
      if (data) {
        this.selectTableData = data;
      }
    },
    // 批量操作
    batchOperationBtn(value) {
      let v = this;
      let list = [
        {value: '1', refsName: 'commodityInfo', type: 'importCommodityInfoModal', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000257')},
        {value: '2', refsName: 'importInventory', type: 'importModal', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000765')},
        {value: '3', refsName: 'batchPrice', type: 'importModal', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006978')},
        {value: '4', refsName: 'batchListing', type: 'importModal', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006979')},
      ];
      list.map((item) => {
        if (item.value === value) {
          if (value === '1') {
            v.$refs['commodityInfo'].initImportCommodityInfoData();
          } else {
            v.$refs[item.refsName][item.type] = true;
          }
        }
      });
    },
    // 采集1688商品
    collectProductsBtn() {
      const {href} = this.$router.resolve({
        path: '/collectProducts'
      });
      window.open(href, '_blank');
    },
    // 处理列表字段
    handleColumns() {
      let v = this;
      const getCountryPrices = (row, item) => {
        return (row.productGoodsPrices || []).filter(ele => ele.countryCode === item.twoCode).map(ele => ele.supplyPrice);
      };

      const getMinMaxAmount = (list) => {
        if (!list || list.length === 0) return {min: null, max: null};
        return {
          min: Math.min(...list),
          max: Math.max(...list)
        };
      };
      let supplyPriceColumns = [];
      return new Promise((resolve) => {
        getAllCountrysData('cn', true).then((countrysList) => {
          getStoreGoodsData(countrysList).then((nationalSupplyPriceData) => {
            nationalSupplyPriceData.map((item) => {
              let title = item.countryName + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000583') + v.currencyState + "）";
              let key = `${item.twoCode}_supplyPrice`;
              supplyPriceColumns.push({
                title: title,
                key: key,
                minWidth: 170,
                align: 'left',
                render: (h, params) => {
                  const priceList = getCountryPrices(params.row, item);
                  const {min, max} = getMinMaxAmount(priceList);
                  let supplyPrice = '';
                  if (min != null && max != null) {
                    if (min === max) {
                      supplyPrice = amountHandel(min);
                    } else {
                      supplyPrice = amountHandel(min) + ' ~ ' + amountHandel(max);
                    }
                  } else {
                    supplyPrice = '-';
                  }
                  const linkName = supplyPrice !== '-' ? supplyPrice + ' ' + (v.currencyState ? '(' + v.currencyState + ')' : '') : '-';
                  return h('Alink', {
                    props: {
                      linkName: linkName,
                      textAlign: 'left',
                      className: 'themeColor',
                      AlinkShow: true
                    },
                    on: {
                      AlinkBtn: () => {
                        v.$refs['commodityPrice'].initCommodityPriceData('supplyPrice', params.row, item);
                      }
                    }
                  });
                }
              })
            });
            v.tableColumns.splice(v.tableColumns.length - 3, 0, ...supplyPriceColumns);
            resolve(true);
          });
        });
      });
    }
  },
  watch: {
    // 监听重置列表数据
    pageParamsStatus(value) {
      let v = this;
      if (value) {
        v.getList();
        v.pageParamsStatus = false;
      }
    }
  },
};
</script>
<style lang="less" scoped>
.tabs_styles {
  /deep/ .ivu-tabs-bar {
    border-bottom: none;
    background-color: #fff;
    padding: 8px 0 3px 0;
    margin: 0;
  }
}
</style>
